module.exports = __webpack_public_path__ + "static/media/attackOfTheClones.46ced14e.jpg";